import ContentLayout from '@/layouts/content-layout'
import FeedView from '@/sections/feeds/view/feed-view'

export default function Feed() {
  return (
    <ContentLayout title="ฟีด">
      <FeedView />
    </ContentLayout>
  )
}
